import { Box } from "@mui/system"

function JugadoresTabComponent() {
	return <Box>WIP</Box>
}

export default JugadoresTabComponent
